export default {
  information_updated: 'Information has been updated',
  updated: '{msg} has been updated',
  toggle: '{msg} has been set to {status}',
  removed: '{msg} has been removed',
  reset: '{msg} has been reset',
  stopped: '{msg} STOP signal has been sent',
  restarted: '{msg} RESTART signal has been sent',
  uploaded: 'File has been uploaded',
  saved: '{title} has been saved',
  listSaved: 'List has been saved',
  listItemSaved: 'List item has been saved',
  added: '{msg} has been added',
  new: 'New {msg}',
  message: '{msg}',
  unselected: 'No rows selected',
  serverWas: '{status} signal is sent to "{server}"...',
  pipelineWas: 'Turned pipeline "{pipeline}" state to {status}',
  moduleWas: 'The module "{module}" has been {status}',
  userWas: 'The user "{user}" has been {status}',
  user: {
    removed: 'removed',
    updated: 'updated',
    saved: 'saved',
    added: 'added',
    deleted: 'deleted'
  },
  server: {
    running: 'RUN',
    stopped: 'STOP',
    deleted: 'DELETE'
  },
  default: {},
  danger: {},
  success: {},
  info: {}
}
